/* eslint-disable sort-keys-fix/sort-keys-fix */
import { assign, createMachine } from "xstate";

import { CheckoutUser } from "../types/checkout";
import { OrderPayment } from "../types/order";
import { PosCustomerInfo } from "../types/user";

interface CheckoutContext {
  customer: CheckoutUser;
  customerInfo: PosCustomerInfo;
  orderNote: string;
  payments: OrderPayment[];
  remainingBalance: number;
  orderId: string;
}

const assignCustomer = assign<CheckoutContext, { type: "ASSIGN_CUSTOMER"; customer: CheckoutUser }>({
  customer: (_, event) => event.customer,
});

const assignPaymentBalances = assign<CheckoutContext, any>({
  remainingBalance: (_, event) => event.remainingBalance,
});

const assignOrder = assign<CheckoutContext, any>({
  orderId: (_, event) => event.orderId,
  customer: (_, event) => event.customer,
  customerInfo: (_, event) => event.customerInfo,
  orderNote: (_, event) => event.orderNote,
  remainingBalance: (_, event) => event.remainingBalance,
  payments: (_, event) => event.payments,
});

const assignOrderNote = assign<CheckoutContext, any>({
  orderNote: (_, event) => event.orderNote,
});

//  @ts-ignore
const resetContext = assign<CheckoutContext, any>(() => {
  return {
    customerInfo: null,
    orderNote: null,
    eyeInfo: null,
    defaultEyeInfo: null,
    payments: [],
    remainingBalance: null,
    orderId: null,
  };
});

export const checkoutMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QGMAWZkGsD2BXALgLICGaAlgHZgDEASgKIDK9AKgPoAajLAgi-QG0ADAF1EoAA7ZYZfGWwVxIAB6IALACYANCACeiAIwa1AOgCsFgMxqA7EI0G7ZoTYC+rnWgw4CJclRNKWTJiABtqHkZGAEkAcQA5NgBhAFVuAHlCelo2aPiAMXThMSQQKRk5BSVVBEsXEwBODQc1AwA2AA4OhstmnX0EM2aTa0sGtQ6bDRs1ezb3T3QsPCJSVEowQIpgsOoAEXoABXSY9gAhHgAZHnikwVElcuCq0preyxM1NoahMb+zHo2fqIBpmEwdMyaYyTb6teYeEBeZa+NYbExUADu6QAThAwNiTGhsGRkGAeLAZFAKBEonFEulaAccvF0vxio9pM9FK9EG0zG0TC5mhYOgYhGZLG1LMCEB1bCNLDY2jYbA0DL01F8Foilj5Vv5NpicXiCUSSWSKWQqTSYgk2PQAJr0XIFIoPUpPSrc0A1NrfEw2ZxtWbNb4dBwywMaQVS+wQtRDNXwxbeFZ+dYBI24-GE1DE0nkynUyK2xIXa63e4lSScr3VXlmGwmDTdOwGJpmdqNmV8gU2LqWMWNsYAtwIpF69NorMm3P5i1Fm10tiHHgOrLxFiMdke2vyb0qEEaMFCiHH2zdcYypqmGzt0WKxy9Mzaidp1GZsBY7OmvPmwtWsWtJ2qu670Ju24GNWZR7i8Pq8vUXyTJYFjjPYPQyvyBjmOqfpGEIbRCARHSvrq74GuiX7GjmEjELoAC2YAUPgsCMGAoQYPgkDUEkDB8M6DJMjuNYVPu9YIAYswNM2BE-EIoIWKq17ypqmpEW0jhERMpGpiiFEzjmyDYmAxByBQUDUdi1AQAomyUAAbtgmCbEZJlcZZwkwaJcGHggGiEeYxi9k0DQdO817TIKkztH6nRYRoOnIvqGabHinpnGExAUKSJiwOxnGUFAhx0YxzFLiBa4blunmemJPIID8HwNKq4p3pYEJKm0MrNB0gotkIBiTBo4xqGMY4pklU4BGltYZaEWU5XlHHIGZRUlUx+DlYkoFVZB0G1T5NRmB0AqKmoaGDbYBFmDKBjOCYwbHS2YWaO1BiJZOH6pWA6WZdlmwAEZ-aSxUMRtrH5St3GgWw5Y3HcNWwQeNSSQm5iQhjMw9BYajdfdUZtM0KoNA0cXJjqunJWiM0VHNC2bLRuiFXT-3WbZWyOc5JiMyzpKI95yOIP5QiBV8x7+cq1i43oiAoWCKqjR0cb+e1CbuAiFDYHi8ClG+ekpRyAviQAtF1MsIMbxiCkRNu27b40U5NX1bDsoSG1y4kOGCvS-MeFjyXYvS3Spthqi4g2ioTH3kSllHfia7t1vVqGfJ0Nhy2hw3SubtimO2LjWO04xSiR45kfr05UT+c7-paVKJ3V8EIN8IsaO1PwOERRc3eb4xNhpbegl0CZKi+ZeU1NhpV7OjOlSxbHLVxEAN4dhgONJnY9KFTjTMqyn90YkpzChapqNHFefvHhnGaZhWWSvgsScd-fOHK1ixaN0sDDeJjtkqrRv2mD0c+VNpo-VmsDMAD9xISl6mdC6co7B8h7B8Xow026QnGEYdoIDJ4mBprIXmmwloFXMqDOe0D6p8mjKFQmfpEHGGanjEWTRxRIXFPyEm5M9agO+r9ea-0TBAwESDdazEIaL0gJQpuBh7yfGPGndOQguiOGYY0DQbDOgcO+KTXBzsCH4CIdzOizNIHSN8u0O65hlHNTlBME6LhuqRWcMdUmoUTqSmDOrVwQA */
    context: {
      //  @ts-ignore
      customer: null,
      //  @ts-ignore
      customerInfo: null,
      //  @ts-ignore
      orderNote: null,
      payments: [],
      //  @ts-ignore
      remainingBalance: null,
      //  @ts-ignore
      orderId: null,
    },
    id: "checkoutMachine",
    initial: "initial",
    on: {
      RESET_XSTATE: {
        actions: "resetContext",
        target: "initial",
      },
    },
    predictableActionArguments: true,
    schema: {
      context: {} as CheckoutContext,
    },

    states: {
      initial: {
        on: {
          ASSIGN_CUSTOMER: {
            actions: "assignCustomer",
          },
          ASSIGN_ORDER_NOTE: {
            actions: "assignOrderNote",
          },
          ASSIGN_BALANCE: {
            actions: "assignPaymentBalances",
          },
          ASSIGN_ORDER: {
            actions: ["assignOrder"],
          },
          ORDER_COMPLETED: {
            actions: ["resetContext"],
          },
        },
      },
    },
  },

  {
    actions: {
      assignCustomer,
      assignPaymentBalances,
      assignOrderNote,
      resetContext,
      assignOrder,
    },
  }
);
